import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { caseSearch, documentGenerate } from '../../../slices/eligibility/eligibilitySlice';
import ImageComponent from '../../common/Image';
import Loader from '../../common/Loader';

function Cancel() {
    const navigate = useNavigate();

    const urlParams = new URLSearchParams(window.location.search);
    const referenceId = urlParams.get('referenceId');
    const [response, setResponse] = useState('')
    const [loader, setLoader] = useState(false)
    const dispatch = useDispatch()
    const [showNumber, setShowNumber] = useState(false);

    const fetchStatusDetails = useCallback(async () => {
        if (referenceId) {

            setLoader(true)

            try {
                let response = await dispatch(caseSearch({
                    "reference_id": referenceId,
                })).unwrap();
                setLoader(false)
                if (response?.response_code === 'S100') {
                    setResponse(response?.response_data)
                    setLoader(false)
                } else {
                    setLoader(false)
                    !response?.payload?.error &&
                    toast.error(response?.data?.response_string);
                }
            } catch (error) {
                setLoader(false)
                toast.error('An error occurred while fetching product data');
            }
        }
    }, [referenceId, dispatch]);

    const handleLink = () => {
        navigate(`/consumerId?referenceId=${referenceId}`)
    }

    useEffect(() => {
        React.memo(fetchStatusDetails());
    }, [fetchStatusDetails]);

    const handleDocumentView = async (documentType) => {
        // Only show loader for KFS view (not generate)
        try {
            const payload = {
                reference_id: referenceId,
                document_type: documentType,
                language: "English",
                action: 'view'
            };
            setLoader(true)
            const response = await dispatch(documentGenerate(payload)).unwrap();
            setLoader(false)
            if (response?.response_code === "S100") {
                // Handle different response data structures
                const responseData = response?.response_data;

                if (responseData?.url) {
                    // If URL is provided, open in new tab
                    window.open(responseData.url, '_blank');
                } else if (responseData?.kfs_image_base64 && payload.action === "view") {
                    // If KFS base64 is provided for view action, create blob and open
                    const pdfBlob = new Blob([Uint8Array.from(atob(responseData.kfs_image_base64), c => c.charCodeAt(0))],
                        { type: 'application/pdf' });
                    const pdfUrl = URL.createObjectURL(pdfBlob);
                    window.open(pdfUrl, '_blank');
                    // Clean up the URL after opening
                    setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
                } else if (responseData?.pdfBase64) {
                    // If base64 PDF is provided, create blob and open
                    const pdfBlob = new Blob([Uint8Array.from(atob(responseData.pdfBase64), c => c.charCodeAt(0))],
                        { type: 'application/pdf' });
                    const pdfUrl = URL.createObjectURL(pdfBlob);
                    window.open(pdfUrl, '_blank');
                    // Clean up the URL after opening
                    setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
                } else if (responseData?.letter_image_base64) {
                    // If base64 image/document is provided
                    const docBlob = new Blob([Uint8Array.from(atob(responseData.letter_image_base64), c => c.charCodeAt(0))],
                        { type: 'application/pdf' });
                    const docUrl = URL.createObjectURL(docBlob);
                    window.open(docUrl, '_blank');
                    // Clean up the URL after opening
                    setTimeout(() => URL.revokeObjectURL(docUrl), 1000);
                } else {
                    toast.error('Document not available for viewing');
                }

                // Show success message if available
                if (responseData?.message) {
                    // toast.success(responseData.message);
                }
            } else {
                !response?.payload?.error &&
                toast.error(response?.response_string || 'Failed to generate document');
            }
        } catch (error) {
            console.error('Error generating document:', error);
            toast.error('Failed to generate document');
        }
    };

    return (
        <>
            {loader === true && <Loader />}
            <div class="position-relative ">
                <header class="sticky-top rounded-0">
                    <div class="container-fluid topNav-dash">
                        <div class="web-header">
                        </div>
                        <div class="mob-header">
                            <div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="text-white fs-6 d-flex py-2 mt-2 align-items-center gap-1">
                                        <span class="icon-arrowleftl1 fs-2"
                                            onClick={() => navigate('/dashboard')}
                                            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/dashboard')}
                                            tabIndex={0}
                                            role="button"
                                        ></span> {response?.status?.replace(/^./, c => c.toUpperCase())}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
            <div class="container-fluid kyc-tab-dash-app height-scroll text-center">
                {response?.status && <ImageComponent fileName={`${response?.status?.toLowerCase() === 'cancelled' && 'Cancelled.png' || response?.status?.toLowerCase() === 'hold' && 'Hold.png' || response?.status?.toLowerCase() === 'rejected' && 'Declined.png' || response?.status?.toLowerCase() === 'queue' && 'Queue.png' || (response?.status?.toLowerCase() === 'approved' || response?.status?.toLowerCase() === 'disbursed') && 'Approved.png' || response?.status?.toLowerCase() === 'in-progress' && 'Inprogress.png'}`} width='250px' height='250px' />}
                <p class="fw-normal mt-3 fs-6 lh-base">The Application Number <span class="dark-blue fw-semibold">
                    {response?.reference_id}
                </span> for the Customer <span class="dark-blue fw-semibold">{response?.first_name} {response?.last_name}</span> is {response?.status}</p>
                <div class="exist-pop">
                    {response?.mobile_number && <div className="col-12 col-lg-12 col-md-12">
                        <p className="d-flex justify-content-between align-items-center">
                            <span>Mobile No.</span>
                            <span className="dark-blue fw-semibold d-flex align-items-center" 
                                    onClick={() => setShowNumber(!showNumber)}
                                    onKeyDown={(e) =>
                                        (e.key === "Enter" || e.key === " ") && setShowNumber(!showNumber)
                                    }>
                                {showNumber ? response?.unmasked_mobile_number : response?.mobile_number}
                            </span>
                        </p>
                    </div>
                    }
                    {response?.dealer_name && <div class="col-12 col-lg-12 col-md-12">
                        <p class=" d-flex justify-content-between">Dealer Name <span class="dark-blue fw-semibold">{response?.dealer_name}</span></p>
                    </div>}
                    {response?.selected_sku?.brand_name && <div class="col-12 col-lg-12 col-md-12">
                        <p class=" d-flex justify-content-between">Brand<span class="dark-blue fw-semibold">{response?.selected_sku?.brand_name}</span></p>
                    </div>}
                    {response?.selected_sku?.description && <div class="col-12 col-lg-12 col-md-12">
                        <p class=" d-flex justify-content-between">Model <span class="dark-blue fw-semibold">{response?.selected_sku?.description}</span></p>
                    </div>}
                    {response?.approved_amount && <div class="col-12 col-lg-12 col-md-12">
                        <p class=" d-flex justify-content-between">Approved Amount <span class="dark-blue fw-semibold">{response?.approved_amount}</span></p>
                    </div>}
                    {(response?.stage && response?.status === 'approved') && <div class="col-12 col-lg-12 col-md-12">
                        <p class=" d-flex justify-content-between">Stage <span class="dark-blue fw-semibold">{response?.stage}</span></p>
                    </div>}
                    {(response?.sub_stage && response?.status === 'approved') && <div class="col-12 col-lg-12 col-md-12">
                        <p class=" d-flex justify-content-between">Sub Stage <span class="dark-blue fw-semibold">{response?.sub_stage}</span></p>
                    </div>}
                </div>
                {response?.rejection_reason && <div class="exist-pop mt-3">
                    <div class="col-12 col-lg-12 col-md-12">
                        <h6 class=" d-flex justify-content-between">{response?.rejection_reason}</h6>
                    </div>
                </div>}
                {(response?.status === 'hold' || response?.status === 'approved') &&
                    <div className="col-lg-12 col-12 col-md-12 col-sm-12 mt-3">
                        <button className="btn btn-primary w-50" type="button" onClick={() => { handleLink() }}>Proceed</button>
                    </div>
                }
                {(response?.status?.toLowerCase() === 'queue' || response?.status?.toLowerCase() === 'disbursed' || response?.status?.toLowerCase() === 'hold' || response?.status?.toLowerCase() === 'approved') &&
                    <>
                        {(response?.status?.toLowerCase() === 'queue' || response?.status?.toLowerCase() === 'disbursed' || response?.status?.toLowerCase() === 'hold' || (response?.status?.toLowerCase() === 'approved' && (response?.stage === 'invoice_details'))) && 
                        <div className="d-flex justify-content-center align-items-stretch gap-3 mt-3" style={{ width: '100%' }}>
                            <button className='btn btn-outline-primary w-100 text-truncate cancel-page-btns' onClick={() => { handleDocumentView('do'); }}><i className='icon-Contentdocument-download me-2'></i>DO Summary</button>
                        </div>}
                        {(response?.status !== 'approved' || (response?.status?.toLowerCase() === 'approved' && (response?.stage === 'imei_validation' || response?.stage === 'invoice_details'))) && <div className="d-flex justify-content-center align-items-stretch gap-3 mt-3" style={{ width: '100%' }}>
                            <button className='btn btn-outline-primary w-100 text-truncate cancel-page-btns' onClick={() => { handleDocumentView('pre_do'); }}><i className='icon-Contentdocument-download me-2'></i>Pre-DO Summary</button>
                        </div>}
                        {(response?.status !== 'approved' || (response?.status?.toLowerCase() === 'approved' && (response?.stage === 'imei_validation' || response?.stage === 'invoice_details'))) && <div className="d-flex justify-content-center align-items-stretch gap-3 mt-3" style={{ width: '100%' }}>
                            <button className='btn btn-outline-primary w-100 text-truncate cancel-page-btns' onClick={() => { handleDocumentView('application'); }}><i className='icon-Contentdocument-download me-2'></i>Application</button>
                        </div>}
                    </>
                }
            </div>
        </>
    )
}

export default Cancel